import React, {useState} from 'react';
import ReactHtmlParser from 'react-html-parser';
import s from './InfoTemplate.module.css';
import ServerData from '../../serverData';
import CacheData from '../../../common/utils/cacheData';
import {fileToBase64} from "../../../../utils/fileToBase64";
import {useDispatch, useSelector} from "react-redux";
import {hideLoader, showLoader} from "../../../store/common/slice";
import ErrorsHandler from "../../errors/handleErrors";

/**
 * @param {'bank-charge-permission' | 'building-bank-charge-permission'}  typeOfUpload
 * */
export default function InfoTemplate({bank, setActiveBank, setFinalPage, typeOfUpload}) {
    const [activeTab, setActiveTab] = useState(0);
    const buildingID = useSelector(state => state.buildings.managerData.buildingID);
    const dispatch = useDispatch();

    const handleTabClick = (i) => () => {
        setActiveTab(i);
    };

    const handleBtnClick = (direction) => () => {
        if (direction === 'prev') {
            setActiveTab((prevState) => {
                if (prevState === 0) {
                    setActiveBank(null);
                    return 0;
                }
                return prevState - 1;
            });
        } else if (direction === 'next') {
            setActiveTab((prevState) => {
                if (prevState === bank.steps.length - 1) {
                    setActiveBank(null);
                    return 0;
                }
                return prevState + 1;
            });
        }
    };

    const handleSuccess = () => {
        // setFinalPage(true);
        setActiveTab(bank.steps.length - 1);
    };

    async function handleFileInputChange(evt) {
        const files = evt.target.files;
        if (files && files[0]) {
            const imageBase64 = await fileToBase64(files[0]);
            await uploadPhoto(imageBase64, files[0].name);
        }
    }

    const uploadPhoto = async (imageBase64, name) => {
        const tenantDetails = CacheData.fetchCache('tenantDetails');
        const cartID = CacheData.fetchCache('cartID');
        // upload tenant details + cartID from localstorage along side the photo. {extraInformation: {tenantDetails: {...}, cartID: '11111'}}
        const extraInformation = typeOfUpload === 'building-bank-charge-permission' ? { buildingID } : {
            ...(tenantDetails && { tenantDetails }),
            ...(cartID && { cartID }),
        };
        try {
            dispatch(showLoader());
            const client = new ServerData();
            await client.images.upload(imageBase64, name, typeOfUpload, extraInformation);
            handleSuccess();
        } catch (e) {
            ErrorsHandler.notifyClientError(e);
        } finally {
            dispatch(hideLoader());
        }
        
    };

    const step = bank.steps[activeTab];
    return (
        <div
            className={`row justify-content-center align-items-center flex-sm-column flex-sm-column-reverse flex-lg-row flex-lg-row-reverse ${s.wrapper}`}
        >
            <div className={`col-sm-12 col-md-12 col-lg-6 ${s.noPadding}`}>
                {step.he.finalStep ? (
                    <div className={`${s.screenshotFinalStepWrapper}`}>
                        <div className={s.titleLogotypeWrapper}>
                            <div
                                className={`row justify-content-center ${s.logotypeImgWrapper}`}
                            >
                                <img
                                    className={`col-sm-7 col-lg-7 ${s.logotype}`}
                                    src={step.he.finalStep.logotype}
                                    alt="Logotype of Bllink"
                                />
                            </div>

                            <div
                                className={s.stepContent}
                            >
                                {ReactHtmlParser(step.he.finalStep.title_logotype)}
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className={`${s.screenshotWrapper}`}>
                        <div
                            className={`row justify-content-center align-items-center ${s.innerRow}`}
                        >
                            <img
                                className={`col-sm-11 col-lg-11 ${s.screenshot}`}
                                src={step.he.stepScreen}
                                alt="Screenshot of site"
                            />
                        </div>
                    </div>
                )}
            </div>

            <div className={`col-sm-12 col-md-12 col-lg-6 ${s.noPadding}`}>
                <div className={`${s.info}`}>
                    <div
                        className={`row justify-content-center align-items-center ${s.tubsWrapper}`}
                    >
                        {bank.steps.map((step, i) => {
                            return (
                                <button
                                    key={i}
                                    onClick={handleTabClick(i)}
                                    className={`${s.tub} ${activeTab === i ? s.activeTab : ''}`}
                                    value={i === activeTab ? '1' : '0'}
                                    type="button"
                                />
                            );
                        })}
                    </div>

                    {step.he.finalStep ? (
                        <>
                            <div
                                className={`row justify-content-center ${s.finalStepTitleRow}`}
                            >
                                <div
                                    className={`col-sm-12 col-lg-12 ${s.stepContent}`}
                                >
                                    {ReactHtmlParser(step.he.title_finalStep)}
                                </div>
                            </div>
                            <div
                                className={`row justify-content-center ${s.innerContentRow}`}
                            >
                                <div
                                    className={`col-sm-12 col-lg-12 ${s.stepContent}`}
                                >
                                    {ReactHtmlParser(step.he.content)}
                                </div>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className={`row justify-content-center ${s.innerTitleRow}`}>
                                <div
                                    className={`col-sm-12 col-lg-12 ${s.stepContent}`}
                                >
                                    {ReactHtmlParser(step.he.title)}
                                </div>
                            </div>
                            <div
                                className={`row justify-content-center ${s.innerContentRow}`}
                            >
                                <div
                                    className={`col-sm-12 col-lg-12 ${s.stepContent}`}
                                >
                                    {ReactHtmlParser(step.he.content)}
                                </div>
                            </div>
                        </>
                    )}

                    {step.he.button && (
                        <div className="row justify-content-center flex-row-reverse">
                            <label
                                htmlFor="upload-bank-charge"
                                className={`${s.inputFileLabel}`}
                            >
                                <div className={`col-10 ${s.downloadWrapper}`}>
                                    <div className={s.inputWrapper}>
                                        <a id="js-upload-link-bank-charge">
                                            <img
                                                className={`${s.btnIcon}`}
                                                src={step.he.button.btnIcon}
                                                alt="Choose file"
                                            />

                                            <input
                                                type="file"
                                                id="upload-bank-charge"
                                                accept="application/pdf"
                                                className={`${s.fileUploadInputBankCharge} js-upload-bank-charge clickable`}
                                                onChange={handleFileInputChange}
                                                hidden
                                            />
                                        </a>

                                    </div>
                                    <div
                                        className={s.stepContent}
                                    >
                                        {ReactHtmlParser(step.he.button.downloadTitle)}
                                    </div>
                                </div>
                            </label>
                        </div>
                    )}

                    <div
                        className={`row flex-row-reverse justify-content-center align-items-center ${s.btnWrapper}`}
                    >
                        {step.he.finalStep ? (
                            <>
                                <button
                                    className={`col-sm-12 col-lg-7 ${s.btnFinalStep}`}
                                    type="button"
                                    onClick={handleBtnClick('next')}
                                >
                                    ישיאה רוזאל הרזח
                                </button>
                            </>
                        ) : (
                            <>
                                {step.he.hideNextButton ?
                                    '' : <button
                                        className={`col-sm-12 col-lg-4 ${s.btnPrev}`}
                                        type="button"
                                        onClick={handleBtnClick('next')}
                                    >
                                        המשך
                                    </button>
                                }
                                <button
                                    className={`col-sm-12 col-lg-4 ${s.btnNext}`}
                                    type="button"
                                    onClick={handleBtnClick('prev')}
                                >
                                    אחורה
                                </button>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
